export const locale = {
    lang: 'fr',
    data: {
        ADD: 'Ajouter un paragraphe',
        TITLE: 'Titre',
        SAVE: 'Enregistrer',
        CANCEL: 'Annuler',
    }
};
